import { api } from '@/lib/api/client';

/** Caso 12 parte 2 — mirrors `TrendRow` from ox-platform. */
export interface TrendRow {
  eventId: number;
  eventName: string;
  startDate: string | null;
  endDate: string | null;
  eventStatus: string | null;
  responsesCount: number;
  leadsCount: number;
  prizesDistributed: number;
  prizesDelivered: number;
}

export const trendsApi = {
  byProject: (projectId: number) =>
    api.get<TrendRow[]>(`/xk-trends`, { params: { projectId } }),
  byBrand: (brandId: number) =>
    api.get<TrendRow[]>(`/xk-trends`, { params: { brandId } }),
};
